import { PanResponder } from 'react-native';
import { isAndroid } from '@dbk/ui-react-utils';
import { cartesianToPolar } from './geometry';
import { TAU } from './donut-chart-constants';

export default function donutChartInteraction({
  onStart,
  onEnd,
  onAngleChange,
  getSize,
  distanceMin,
  distanceMax,
  onSelectAngle,
}) {
  let previousAngle;
  let size;
  let size2;
  let angleMoved;

  function polarFromEvent(evt, gestureInfo) {
    size = getSize();
    size2 = size / 2;
    let { locationX, locationY } = evt.nativeEvent;

    // On android the location does not change when moving the finger
    if (isAndroid) {
      locationX += gestureInfo.dx;
      locationY += gestureInfo.dy;
    }

    const { rads: angle, radius } = cartesianToPolar(
      locationX - size2,
      locationY - size2
    );
    return { angle, radius };
  }

  const panResponder = PanResponder.create({
    onStartShouldSetPanResponderCapture:  () => true,
    onMoveShouldSetPanResponderCapture:  () => false,
    onPanResponderGrant: (evt, gestureInfo) => {
      previousAngle = polarFromEvent(evt, gestureInfo).angle;
      onStart();
    },
    onPanResponderTerminationRequest: () => false,
    onPanResponderTerminate:  () => onEnd(previousAngle),
    onPanResponderRelease: () => {
      onEnd(previousAngle);
    },
  });

  return panResponder.panHandlers;
}
